import axios from "axios";

export const EXTENDED_TIMEOUT = 30000;

export const postWithTimeout = (data, timeout) => {
	const {command} = data;
	const timedData = {...data, command: {...command, timeout}};
	return axios.post('/nologin/api', timedData, {timeout});
};
